import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Hyperlink from '@classify/react-core-components/Hyperlink';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import usePromotionProps from './usePromotionProps';
const Root = styled('div')(({
  theme: {
    spacing,
    palette,
    radius
  }
}) => ({
  borderRadius: radius.menu,
  background: palette.notification.info.background,
  margin: spacing(0, 1, 1),
  padding: spacing(1.5)
}));
export default function MenuItemJobPostingPromotion() {
  const $ = _c(9);
  const promotionProps = usePromotionProps();
  if (!promotionProps) {
    return null;
  }
  let t0;
  if ($[0] !== promotionProps.description) {
    t0 = <Typography variant="bodySmall" component="div" dangerouslySetInnerHTML={{
      __html: promotionProps.description
    }} />;
    $[0] = promotionProps.description;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginTop: 2
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== promotionProps.ctaLabel || $[4] !== promotionProps.ctaProps) {
    t2 = <Box sx={t1}><Hyperlink variant="large" underline="none" {...promotionProps.ctaProps}>{promotionProps.ctaLabel}</Hyperlink></Box>;
    $[3] = promotionProps.ctaLabel;
    $[4] = promotionProps.ctaProps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <Root>{t0}{t2}</Root>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}